import { useState } from "react";
import type { ProfileData, EditableTabProps } from "../../../lib/profileTypes";
import { SectionCard } from "../card/SectionCard";
import { InfoRow } from "../row/InfoRow";

const LINKS: [string, string][] = [
  ["linkedin", "LinkedIn"],
  ["github", "GitHub"],
  ["facebook", "Facebook"],
  ["twitter", "Twitter / X"],
  ["instagram", "Instagram"],
  ["tiktok", "TikTok"],
  ["website", "Website"],
];

interface SocialTabProps extends EditableTabProps {
  profile: ProfileData;
}

export function SocialTab({
  profile,
  editing,
  onEdit,
  onSave,
  onCancel,
  saving,
}: SocialTabProps) {
  const [form, setForm] = useState({ ...profile });
  const f = (k: string) =>
    ((form as Record<string, unknown>)[k] as string) || "";
  const set = (k: string, v: string) => setForm({ ...form, [k]: v });

  if (!editing) {
    return (
      <SectionCard title="Social Media & Links" onEdit={onEdit}>
        {LINKS.map(([k, l]) => (
          <InfoRow
            key={k}
            label={l}
            value={(profile as Record<string, unknown>)[k] as string}
          />
        ))}
      </SectionCard>
    );
  }

  return (
    <div className="space-y-4">
      <SectionCard title="Social Media & Links" editing>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
          {LINKS.map(([k, l]) => (
            <div key={k}>
              <label className="text-[10px] font-semibold uppercase text-text-secondary">
                {l}
              </label>
              <input
                value={f(k)}
                onChange={(e) => set(k, e.target.value)}
                placeholder={`${l} URL`}
                className="mt-0.5 w-full rounded-btn border border-border-card bg-white px-2.5 py-1.5 text-xs text-near-black focus:outline-none focus:shadow-focus"
              />
            </div>
          ))}
        </div>
      </SectionCard>
      <div className="flex gap-2">
        <button
          onClick={() => onSave(form)}
          disabled={saving}
          className="rounded-btn bg-near-black px-4 py-2 text-sm font-medium text-white hover:bg-rausch disabled:opacity-50"
        >
          {saving ? "Saving..." : "Save"}
        </button>
        <button
          onClick={onCancel}
          className="rounded-btn px-4 py-2 text-sm font-medium text-text-secondary hover:text-near-black"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
